/**
 * auth模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例
import store from '../store';
import common from '../common'

let commonUtils = require('@/utils/common_utils');
const order = {
    //获取当前购物车
    getOrder() {
        return axios.get(base.dev + '/orders/active');
    },
    //获取购物车列表
    getOrderGroup() {
        return axios.get(base.dev + '/v2/commandes/getOrderGroup');
    },
    //获取购物车列表单个订单组
    getOrderGroupActive(params) {
        return axios.get(base.dev + '/v2/commandes/active', {params});
    },
    //获取选中订单
    SelectedOrder() {
        return axios.get(base.dev + '/orders/selected');
    },
    /*以下接口都是获取商家信息，一共两个接口*/
    //获取商家信息
    getInfo(obj) {
        return axios.get(base.dev + `/v2/vendeurs/account/info/?id_vendeur=${obj.id}&id_language=${obj.lang}`);
    },
    //了解更多
    getMore(id) {
        return axios.get(base.dev + `/vendeurs/${id}`);
    },
    /*以上接口都是获取商家信息，一共两个接口*/

    //添加/取消收藏
    addFavorite(obj) {
        return axios.post(base.dev + `/acheteurs/marques/${obj.id}`);
    },
    //初始化获取商家是否收藏了商家
    getIsCollect(obj) {
        return axios.get(base.dev + `/acheteurs/marques/${obj.id}`);
    },
    //获取折扣
    getDiscount(obj) {
        if (!store.state.token) return new Promise(resolve => {
        });
        let queryParamsStr = commonUtils.convertObj2QueryParams(obj);
        return axios.get(base.dev + `/v2/remises/list?${queryParamsStr}`);
    },
    //获取商家产品
    getProduction(obj) {
        return axios.post(base.dev + `/v2/vendeurs/produits/list?id_vendeur=${obj.id_vendeur}&page=${obj.page}&pageSize=${obj.pageSize}&type=${obj.type}`);
    },
    //选择加入订单组
    selectOrder(obj) {
        return axios.post(base.dev + `/v2/commandes/selectOrder`, obj);
    },
    //删除产品
    removeProduits(obj) {
        return axios.post(base.dev + `/v2/commandes/removeProduits`, obj);
    },
    //打折码检查
    queryRemiseCode(obj) {
        return axios.post(base.dev + `/v2/remises/queryRemiseCode`, obj);
    },
    //修改购物车某个产品数量
    changeQuantity(obj) {
        return axios.post(base.dev + `/v2/commandes/changeQuantity`, obj);
    },
    //下单拉起支付接口
    pay(obj) {
        return axios.post(base.dev + `/v2/commandes/paiement`, obj, {timeout: 25 * 1000});
    },
    //查询订单支付状态
    getPayStatus(obj) {
        return axios.post(base.dev + `/v2/commandes/payCallback`, obj);
    },
    //下载订单图片
    downloadPictures(obj) {
        return axios.get(base.dev + `/v2/produits/downloadPictures?id_commande=${obj.id_commande}`,);
    },
    //下载订单发票图片
    onClickDownloadOrderBillImg(obj) {
        //https://www.efashion-paris.com/front/files/commandes/factures/2020-09(订单年-月)/258572（id_commande_groupe）/1965782(id_commande)-1(文件数)-popindiff（商家名称）.pdf
        return axios.get(`${common.imgHost}/front/files/commandes/factures
        /${obj.downloadTime}/${obj.id_commande_groupe}/${obj.id_commande}-1-${obj.vendeur.nomSociete}`);
    },
    //把这个产品ligne移动到之后处理
    move_to_handle_later(obj) {
        return axios.post(base.dev + `/v2/commandes/move_to_handle_later`, obj);
    },
    //获取之后处理的产品
    get_handle_later() {
        return axios.get(base.dev + `/v2/commandes/get_handle_later`);
    },
    //获取购物车已选择的订单的买家信息
    get_order_vendeur_data() {
        return axios.get(base.dev + `/v2/commandes/get_order_vendeur_data`);
    },
    //获取买家是否要扣税数据
    get_buyer_is_tva(params) {
        return axios.get(base.dev + `/v2/commandes/get_buyer_is_tva`, {params: params});
    },
    //获取买家是否要扣税数据
    get_buyer_is_tva_cart_default(params) {
        return axios.get(base.dev + `/v2/commandes/get_buyer_is_tva_cart_default`, {params: params});
    },
    //确认选择订单
    confirm_choose_order(params) {
        return axios.post(base.dev + `/v2/commandes/confirm_choose_order`, params);
    },
    //获取可用支付方式
    get_available_payment_types(params) {
        return axios.get(base.dev + `/v2/commandes/get_available_payment_types`, {params});
    },

}
export default order;
